export const enum Plan {
    FREE = 'free',
    BASIC = 'basic',
    PREMIUM = 'premium',
}